module.exports = __webpack_public_path__ + "static/Moonlighter2-8e6b3433f42ca8dabe8ce59a589a1187.webp";